import React, { useState, useEffect, useRef } from 'react';
import { Typography } from '@mui/material';
import StepIcon from '#component/icon/step-icon/step-icon';
import DateLabel from './date-label';
import {
  StyledStep,
  StyledStepLabel,
  StyledStepContent,
  Address,
  ContentWrapper,
  ConnectorVerticalLast,
  ConnectorHorizontal,
  ConnectorHorizontalOnly,
  ConnectorSpaceOnly,
  ContentCnt
} from './styles';
import { getFormattedDate } from '#helper';

const getStepLabel = (index, isLastIndex) =>
  (index === 0 ? 'ORIGIN' : isLastIndex ? 'DESTINATION' : 'CHECKPOINT');

const getStepMessage = (step, index, account) => {
  let message = null;

  if (step.done) {
    if (step.locations) {
      message =
        <span>
          Geofence triggered on
          <br />
          {getFormattedDate(step.done, account)}
        </span>;
    } else {
      message = 'Completed';
    }
  }

  return message;
};

export const getAddressString = (address = {}) => {
  const addressArray = [];

  if (address.address1) {
    addressArray.push(address.address1);
  }
  if (address.city) {
    addressArray.push(address.city);
  }

  if (!address.address1 && !address.city) {
    if (address.state) {
      addressArray.push(address.state);
    }
    if (address.country) {
      addressArray.push(address.country);
    }
  }

  return addressArray.join(', ');
};

const getStoppedLabel = (step, index, account, shipment) => {
  let message = null;

  if (shipment?.shipmentStatus?.code === 3 && index === shipment.delivery.length - 1) {
    message =
      <span>
        Stopped at&nbsp;
        {getFormattedDate(shipment.shipmentStatus.timestamp, account)}
      </span>;
  }

  return message;
};

export default props => {
  const {
    state,
    index,
    states,
    account,
    handleClick,
    handleHover,
    shipment,
    showInTooltip
  } = props;
  const [lastVerticalConnectorColor, setLastVerticalConnectorColor] = useState('transparent');

  const ref = useRef();
  const statusLabel = getStepMessage(state, index, account);
  const addressLabel = getAddressString(state.address);
  const stoppedLabel = getStoppedLabel(state, index, account, shipment);

  useEffect(() => {
    if (index === states.length - 1 && ref.current?.parentElement) {
      let bgColor;
      let parentEl = ref.current.parentElement;

      do {
        const parentBgColor = window.getComputedStyle(parentEl, null).getPropertyValue('background-color');
        if (parentBgColor !== 'rgba(0, 0, 0, 0)' && parentBgColor !== 'transparent') {
          bgColor = parentBgColor;
        }
        if (parentEl.parentElement) {
          parentEl = parentEl.parentElement;
        } else {
          break;
        }
      } while (!bgColor);

      setLastVerticalConnectorColor(bgColor);
    }
  }, [index, states.length, stoppedLabel]);

  return (
    <StyledStep
      className={handleHover ? 'step' : ''}
      expanded={true}
      active={!!state.done}
      onClick={() => handleClick?.(state)}
      onMouseEnter={e => handleHover?.(e, state)}
      onMouseLeave={e => handleHover?.(e, state)}
    >
      <StyledStepLabel
        icon={index + 1}
        className="stepLabelCnt"
        StepIconComponent={StepIcon}
        classes={{
          labelContainer: showInTooltip ? 'stepLabelMap' : 'stepLabelOrigin'
        }}
        StepIconProps={{
          showInTooltip
        }}
      >
        {getStepLabel(index, index === states.length - 1)}
      </StyledStepLabel>
      <StyledStepContent className="stepContent" orientation="vertical" icon={index + 1}>
        {state.date && (
        <DateLabel
          date={state.date}
          account={account}
          active={!!state.done}
          showInTooltip={showInTooltip}
        />
        )}
        {(statusLabel || addressLabel || stoppedLabel) ?
          <ContentWrapper>
            {index === states.length - 1 &&
            !(states.length === 1 && addressLabel && !stoppedLabel) && (
            <ConnectorVerticalLast
              className={showInTooltip ? 'showInTooltip' : ''}
              style={{ backgroundColor: lastVerticalConnectorColor }}
              ref={ref}
            />)}
            {states.length > 1 || stoppedLabel || addressLabel ?
              <>
                <ConnectorHorizontal />
                <ContentCnt>
                  <Typography variant="body2">
                    {stoppedLabel || statusLabel}
                  </Typography>
                  <Address
                    variant="body2"
                    className={showInTooltip ? 'addressInTooltip' : ''}
                  >
                    {addressLabel}
                  </Address>
                </ContentCnt>
              </> :
              <ConnectorSpaceOnly />}
          </ContentWrapper> :
          (index !== states.length - 1) ?
            <ConnectorSpaceOnly /> :
            <ConnectorHorizontalOnly />}
      </StyledStepContent>
    </StyledStep>
  );
};
